<template>
  <div class="live max-content">
    <top :title="nav_title" :color="color" v-if="nav_title && button_id"></top>
    <div class="introduction">
      <div class="cover">
        <van-swipe
          :autoplay="3000"
          indicator-color="white"
          :show-indicators="false"
        >
          <van-swipe-item
            v-for="(item, key, index) in swiperImg"
            :key="index"
            @click="clickSwiperImg(item)"
          >
            <img :src="item.image" alt="" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div>
        <h3>{{ meetingInfo.name }}</h3>
        <!-- <div class="time">
          <p>
            <van-icon name="clock-o" />
            {{
              meeting_id == 525
                ? "2024.12.21 08:30-18:05"
                : meetingInfo.start_at + " - " + meetingInfo.end_at
            }}
            <span v-if="is_collect" @click="collectMeeting"
              ><van-icon name="star" color="#d2020d" />{{ collectStatus }}</span
            >
            <span v-else @click="collectMeeting"
              ><van-icon name="star-o" />{{ collectStatus }}</span
            >
          </p>
        </div> -->
      </div>
    </div>
    <div class="liveDetails">
      <!-- <h3 v-if="meeting_dates.length != 0">会议直播</h3> -->
        <meeting-place
          v-if="meetingDays.length"
          :meetingDays="meetingDays"
          :color="theme_color"
          :rememberDate="false"
          @select="handleScheduleClick"
        />
      <div class="details">
        <!-- <div class="item">
          <span>会议地点 : </span>
          <p v-if="meetingInfo.province && meeting_id == 525">
            {{ meetingInfo.province.name }}{{ meetingInfo.city.name
            }}{{ meetingInfo.address }}
          </p>
          <p v-if="meetingInfo.province && meeting_id != 525">
            {{ meetingInfo.province.name }} {{ meetingInfo.city.name }}
            {{ meetingInfo.address }}
          </p>
        </div> -->
        <div class="item" v-if="meetingInfo.organizers">
          <span>主办单位 : </span>
          <div>
            <p v-html="meetingInfo.organizers"></p>
          </div>
        </div>
        <div class="item" v-if="meetingInfo.contractor">
          <span>承办单位 : </span>
          <div>
            <p v-html="meetingInfo.contractor"></p>
          </div>
        </div>
        <div class="item" v-if="meetingInfo.co_sponsors">
          <span>协办单位 : </span>
          <p v-html="meetingInfo.co_sponsors"></p>
        </div>
        <div
          class="item"
          v-for="(item, index) in customOrganizations"
          :key="index"
        >
          <span>{{ item.title }} : </span>
          <p v-html="item.custom_organizers"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Register from "../../components/Users/Register.vue"
import {
  // MeetingsDetails,
  // MeetingsSchedule,
  // MeetingFollows,
  MeetingsCarousel,
  PersoanalUserInfo,
  MeetingIsCollect,
  ButtonDetail,
  meetingCustomOrganize,
  NewMeetingDetail,
  NewMeetingDays,
} from "../../../config/interface.js";
import { ImagePreview, Skeleton } from "vant"; //预览图片   使用的函数调用
import Top from "../components/Top";
import MeetingPlace from "../components/Meeting/MeetingPlace";
export default {
  components: {
    Top,
    Skeleton,
    MeetingPlace,
  },
  data() {
    return {
      floatWindow: true,
      giftshow: true, //礼物显示
      activityObj: {}, //活动对象
      meeting_id: 0, //会议id
      meetingInfo: {}, //会议信息
      meetingDays: [], //会场日期列表
      meeting_dates: [], //日期会议
      liveList: [], //会议列表
      collectStatus: "",
      swiperImg: {}, //轮播图
      scheduleDate: [],
      meetingSchedule: {},
      userInfo: "",
      is_collect: 0,
      button_id: this.$route.query.button_id
        ? this.$route.query.button_id
        : this.$route.query.b_id,
      theme_color: "#901D22",
      customOrganizations: [],
      nav_title: "大会直播",
      color: "#FFFFFF",
      weekdays: [],
    };
  },
  created() {
    if (common.is_weixin()) {
      //微信端
      this.getUserInfo();
    } else {
      //非微信端
      this.userInfo = this.$store.state.userInfo;
      if (this.userInfo) {
        this.getUserInfo();
      } else {
        this.$router.replace({
          path: "/vascularNews/user/login",
          query: { url: window.location.href },
        });
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    //  修复iOS版微信HTML5 History兼容性问题
    if (to.path !== location.pathname) {
      location.assign(to.fullPath);
    } else {
      next();
    }
  },
  mounted() {},
  methods: {
    //得到用户信息
    getUserInfo() {
      const url = PersoanalUserInfo;
      let params = {};
      const method = "POST";
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {
          let data = res.data;
          localStorage.setItem("userInfo", JSON.stringify(data));
          this.$store.dispatch("storageUserInfo", data);
          this.userInfo = data;
          if (this.userInfo && this.userInfo.mobile_status == 1) {
            this.meeting_id = this.$route.query.meeting_id
              ? this.$route.query.meeting_id
              : this.$route.query.MT_id;
            // this.getMeetingDetails(this.meeting_id);
            // this.getSchedule();
            // this.getCollect();
            this.getMeetingCarousel();
            this.getButtonData();
            this.getMeetingOrganization();

            this.getMeetingDetailsNew(this.meeting_id); //新接口-会议信息
            this.getMeetingDays(); //新接口-会场日期列表
          } else {
            common.toast("未绑定手机", 1000, "fail", () => {
              this.$router.replace({
                path: "/vascularNews/user/login",
                query: { url: window.location.href },
              });
            });
          }
        }
      });
    },
    //获取按钮信息
    getButtonData() {
      if (this.button_id) {
        const url = ButtonDetail;
        let params = {
          button_id: this.button_id,
        };
        const method = "POST";
        fetch(url, params, method).then((res) => {
          if (res.code == 0) {
            this.nav_title = res.data.name;

            if (common.is_weixin()) {
              let data = res.data;
              common.wxShare(
                data.share_title,
                data.share_sub_title,
                data.share_img
              );
            }
          }
        });
      }
    },
    //旧接口-会议日程
    // getSchedule() {
    //   const url = MeetingsSchedule;
    //   let params = {
    //     meeting_id: this.meeting_id,
    //     from_index: 1,
    //   };
    //   const method = "POST";
    //   fetch(url, params, method).then((res) => {
    //     if (res.code == 0) {
    //       var data = res.data;
    //       this.meetingSchedule = data.sessions;
    //       this.scheduleDate = Object.keys(this.meetingSchedule);
    //       const dateObj = data.meeting.start_at.split(" ")[0].split("-")[0];
    //       this.weekdays = [];
    //       this.scheduleDate.forEach((item, i) => {
    //         let d = new Date(
    //           dateObj + "-" + item.replace("月", "-").replace("日", "")
    //         );
    //         this.weekdays[i] = [
    //           "星期日",
    //           "星期一",
    //           "星期二",
    //           "星期三",
    //           "星期四",
    //           "星期五",
    //           "星期六",
    //         ][d.getDay()];
    //       });
    //       if (data.meeting.theme_color_hex) {
    //         this.theme_color = data.meeting.theme_color_hex;
    //       } else {
    //         this.theme_color = "#901D22";
    //       }
    //     }
    //   });
    // },
    //新接口-会场日期列表
    getMeetingDays() {
      fetch(NewMeetingDays(this.meeting_id), {}, "GET").then((res) => {
        if (res.code == 0) {
          let data = res.data;
          this.meetingDays = data;
        }
      });
    },
    // // 会议收藏和取消收藏(关注)
    // getCollect() {
    //   const url = MeetingIsCollect;
    //   let params = {
    //     meeting_id: this.meeting_id,
    //   };
    //   const method = "POST";
    //   fetch(url, params, method).then((res) => {
    //     if (res.code == 0) {
    //       this.is_collect = res.data.is_follow;
    //       console.log(this.is_collect);
    //       if (this.is_collect) {
    //         this.collectStatus = "已收藏";
    //       } else {
    //         this.collectStatus = "收藏";
    //       }
    //     }
    //   });
    // },
        // //会议收藏和取消收藏(关注)
    // collectMeeting() {
    //   const url = MeetingFollows;
    //   const method = "POST";
    //   let params = {
    //     meeting_id: this.meeting_id,
    //   };
    //   fetch(url, params, method).then((res) => {
    //     if (res.code == 0) {
    //       let data = res.data;
    //       data.attach == 0
    //         ? (this.collectStatus = "收藏")
    //         : (this.collectStatus = "已收藏");
    //       data.attach == 0 ? (this.is_collect = 0) : (this.is_collect = 1);
    //     }
    //   });
    // },
    formatTime(time) {
      if (time != null) {
        return time.slice(0, 16);
      }
      return "";
    },
    handleScheduleClick(item) {
      const isSpecialJump =
        String(this.meeting_id) === "787" &&
        String(this.button_id) === "3973" &&
        (String(item.id) === "1934" ||
          String(item.id) === "1957" ||
          String(item.id) === "1958" ||
          String(item.id) === "1959");

      if (isSpecialJump) {
        window.location.href =
          "https://vhbrpa.snet.weizan.cn/plug-ins/#/FixupIndex/1398702087?v=1777526104568&templateId=165596";
        return;
      }

      this.$router.push({
        path: "/vascularNews/meeting/liveDetail",
        query: { meeting_id: this.meeting_id, id: item.id },
      });
    },
    //跳转链接
    skipLink(item) {
      if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
        ImagePreview({
          images: [item.url],
          closeable: true,
          showIndex: false,
        });
      } else {
        window.location.href = item.url;
      }
    },
    //会议轮播
    getMeetingCarousel() {
      const url = MeetingsCarousel;
      let params = {
        meeting_id: this.meeting_id,
      };
      const method = "POST";
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {
          let data = res.data;
          this.swiperImg = data;
        }
      });
    },
    //个性化单位
    getMeetingOrganization() {
      const url = meetingCustomOrganize;
      let params = {
        meeting_id: this.meeting_id,
      };
      const method = "POST";
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {
          let data = res.data;
          this.customOrganizations = data;
        }
      });
    },
    clickSwiperImg(item) {
      window.location.href = item.link;
    },
    //旧接口-会议详情
    // getMeetingDetails(id) {
    //   this.$store.dispatch("isShowLoading", true);
    //   const url = MeetingsDetails;
    //   const method = "POST";
    //   let params = {
    //     meeting_id: id,
    //   };
    //   fetch(url, params, method).then((res) => {
    //     if (res.code == 0) {
    //       let data = res.data;
    //       document.title = data.name;
    //       if (res.data.theme_color_hex) {
    //         this.color = res.data.theme_color_hex;
    //       } else {
    //         this.color = "#901D22";
    //       }
    //       let currentDate = new Date();
    //       let currentTime = currentDate.getTime();
    //       let startTime = new Date(data.start_at.split(" ")[0]).getTime();
    //       let endTime = new Date(data.end_at.split(" ")[0]).getTime();
    //       if (currentTime < startTime) {
    //         data.tipText = "即将开始直播";
    //       } else if (currentTime >= startTime && currentTime < endTime) {
    //         data.tipText = "正在直播";
    //       } else if (currentTime > endTime) {
    //         data.tipText = "观看录播";
    //       }
    //       data.is_follow == 0
    //         ? (this.collectStaus = "收藏")
    //         : (this.collectStaus = "取消收藏");
    //       data.start_at = data.start_at.split(" ")[0].split("-").join(".");
    //       let end_at_arr = data.end_at.split(" ")[0].split("-");
    //       data.end_at = end_at_arr[1] + "." + end_at_arr[2];

    //       if (data.organizers != null) {
    //         data.organizers = data.organizers.replace(
    //           /(\r\n|\n|\r)/gm,
    //           "<br/>"
    //         );
    //       }
    //       if (data.contractor != null) {
    //         data.contractor = data.contractor.replace(
    //           /(\r\n|\n|\r)/gm,
    //           "<br/>"
    //         );
    //       }
    //       if (data.co_sponsors != null) {
    //         data.co_sponsors = data.co_sponsors.replace(
    //           /(\r\n|\n|\r)/gm,
    //           "<br/>"
    //         );
    //       }
    //       this.meetingInfo = data;
    //       // this.meeting_dates=data.meeting_dates;
    //       //微信浏览器  请求jsdk
    //       if (common.is_weixin()) {
    //         common.wxShare(data.name, data.title, data.shareimg);
    //       }
    //     }
    //     this.$store.dispatch("isShowLoading", false);
    //   });
    // },
    //新接口-会议信息
    getMeetingDetailsNew(id) {
      fetch(NewMeetingDetail(id), {}, "GET").then((res) => {
        if (res.code == 0) {
          let data = res.data;
          document.title = data.name;
          if (res.data.theme_color_hex) {
            this.color = res.data.theme_color_hex;
            this.theme_color = res.data.theme_color_hex;
          } else {
            this.color = "#901D22";
            this.theme_color = "#901D22";
          }
          let currentDate = new Date();
          let currentTime = currentDate.getTime();
          let startTime = new Date(data.start_at.split(" ")[0]).getTime();
          let endTime = new Date(data.end_at.split(" ")[0]).getTime();
          if (currentTime < startTime) {
            data.tipText = "即将开始直播";
          } else if (currentTime >= startTime && currentTime < endTime) {
            data.tipText = "正在直播";
          } else if (currentTime > endTime) {
            data.tipText = "观看录播";
          }
          data.is_follow == 0
            ? (this.collectStaus = "收藏")
            : (this.collectStaus = "取消收藏");
          data.start_at = data.start_at.split(" ")[0].split("-").join(".");
          let end_at_arr = data.end_at.split(" ")[0].split("-");
          data.end_at = end_at_arr[1] + "." + end_at_arr[2];

          if (data.organizers != null) {
            data.organizers = data.organizers.replace(
              /(\r\n|\n|\r)/gm,
              "<br/>"
            );
          }
          if (data.contractor != null) {
            data.contractor = data.contractor.replace(
              /(\r\n|\n|\r)/gm,
              "<br/>"
            );
          }
          if (data.co_sponsors != null) {
            data.co_sponsors = data.co_sponsors.replace(
              /(\r\n|\n|\r)/gm,
              "<br/>"
            );
          }
          this.meetingInfo = data;
          // this.meeting_dates=data.meeting_dates;
          //微信浏览器  请求jsdk
          if (common.is_weixin()) {
            common.wxShare(data.name, data.title, data.shareimg);
          }
        }
      });
    },

  },
};
</script>
<style lang="scss">
.live {
  position: relative;

  .introduction {
    padding: 14px 12px;
    border-bottom: 1px solid #f1f2f4;
    background: white;

    .cover {
      margin-bottom: 14px;

      img {
        width: 100%;
        border-radius: 5px;
      }
    }

    h3,
    h4 {
      line-height: 30px;
      color: $color-black;
    }

    h3 {
      font-size: 16px;
    }

    h4 {
      font-size: 13px;
      font-weight: 400;
    }

    .time {
      margin-top: 5px;
      @include flex(row);
      justify-content: space-between;
      align-items: center;

      p {
        width: 100%;
        color: $color-gray;
        font-size: 14px;
        padding-right: 5px;

        span {
          float: right;
          font-size: 14px;
        }
      }

      .operation {
        @include flex(row);
        align-items: center;
      }

      i {
        vertical-align: -4px;
        color: $color-black;
        font-size: 16px;
        margin-right: 3px;
        margin-bottom: 2px;
        vertical-align: middle;
      }

      .attention {
        font-size: 11px;
        color: $color-black;
        padding: 3px 11px;
        border: 1px solid #d3d3d3;
        border-radius: 2px;
      }
    }
  }

  .liveDetails {
   

    h3 {
      font-size: 17px;
      color: $color-black;
      line-height: 30px;
    }

    h4 {
      font-size: 15px;
      color: $color-black;
      line-height: 30px;
    }

    .live-place1 {
      margin: 0;
    }

    .details {
      padding: 0px 12px 10px;
      // margin-top: 10px;

      .item {
        @include flex(row);
        color: $color-gray;
        font-size: 12px;
        letter-spacing: 1px;
        /*no*/
        letter-spacing: 0.46px;
        margin-bottom: 15px;

        p,
        span {
          margin-right: 5px;
          line-height: 20px;
          min-width: 65px;
          text-align: justify;
        }

        p {
          flex: 1;
        }
      }
    }
  }

  .van-popup {
    border-radius: 11px;
  }

  .van-loading {
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translate(-50%, 0);
    z-index: 100;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/Live.vue